import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";
import { BurolarInfo } from "@models/genel/BurolarInfo";
import { SayfalamaSonuc } from "@models_genel/SayfalamaSonuc";
import { BuroBankaInfo } from "@core/models/genel/BuroBankaInfo";
import { IslemSonuc } from "@core/models/genel/IslemSonuc";
import { BuroMuhasebeciMaliMusaivirInfo } from "@core/models/genel/BuroMuhasebeciMaliMusavirInfo";
import { ImzalanmisSozlesmeInfo } from "@core/models/genel/ImzalanmisSozlesmeInfo";
import { HashingHelperService } from "@core/utils/hashing.helper.service";
import { BuroSubeInfo } from "@core/models/genel/BuroSubeInfo";
import { KullaniciInfo } from "@core/models/genel/KullaniciInfo";
import { FaturaNumaraSayacInfo } from "@core/models/fatura/FaturaNumaraSayacInfo";

@Injectable()
export class BurolarService {
	constructor(
		private http: HttpClient,
		private hashingHelper: HashingHelperService
	) { }
	getData(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_BUROLAR_URL, {
			params: parametersModel,
		});
	}
	select(id: number): Observable<BurolarInfo> {
		return this.http.get<BurolarInfo>(
			environment.API_BUROLAR_URL + id.toString()
		);
	}
	ekleGuncelle(entity: BurolarInfo): Observable<any> {

		return this.http.post<BurolarInfo>(environment.API_BUROLAR_URL, entity);
	}
	sil(id: number): Observable<any> {
		return this.http.delete<any>(
			environment.API_BUROLAR_URL + id.toString()
		);
	}
	buroGetir() {
		let promise = new Promise<BurolarInfo>((resolve, reject) => {
			this.http
				.get(environment.API_BUROLAR_URL + "burogetir")
				.toPromise()
				.then((res: any) => {
					var b = JSON.parse(this.hashingHelper.decrypt(res.b));
					resolve(b);
				});
		});
		return promise;
	}

	buroSatinAlmaGecimisiGetir(): Observable<any> {
		return this.http.get<any>(
			environment.API_BUROLAR_URL + "satinalmagecmisi"
		);
	}
	buroKalanBakiyeGetir(): Observable<any> {
		return this.http.get<any>(environment.API_BUROLAR_URL + "kalanbakiye");
	}
	gecisYapilabilecekBurolariGetir(): Observable<any> {
		return this.http.get<any>(
			environment.API_BUROLAR_URL + "gecisyapilabilecekburolarigetir"
		);
	}
	imzalanmisSozlesmeSorgula(): Observable<ImzalanmisSozlesmeInfo> {
		return this.http.get<ImzalanmisSozlesmeInfo>(
			environment.API_BUROLAR_URL + "imzalanmissozlesmesorgula"
		);
	}
	getBankalar(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_BURO_BANKA_URL, {
			params: parametersModel,
		});
	}
	getSubeler(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_BURO_SUBE_URL, {
			params: parametersModel,
		});
	}
	getKullanicilar(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_BURO_KULLANICI_URL, {
			params: parametersModel,
		});
	}
	getGBPKlar(parametersModel?: any): Observable<SayfalamaSonuc> {
		return this.http.get<SayfalamaSonuc>(environment.API_BUROLAR_URL + "getgbpk", {
			params: parametersModel,
		});
	}
	selectBuroBanka(id: number): Observable<BuroBankaInfo> {
		return this.http.get<BuroBankaInfo>(
			environment.API_BURO_BANKA_URL + id.toString()
		);
	}
	selectBuroSube(id: number): Observable<BuroSubeInfo> {
		return this.http.get<BuroSubeInfo>(
			environment.API_BURO_SUBE_URL + id.toString()
		);
	}
	selectBuroKullanici(id: number): Observable<KullaniciInfo> {
		return this.http.get<KullaniciInfo>(
			environment.API_BURO_KULLANICI_URL + id.toString()
		);
	}
	buroBankaEkleGuncelle(entity: BuroBankaInfo): Observable<any> {
		return this.http.post<BuroBankaInfo>(
			environment.API_BURO_BANKA_URL,
			entity
		);
	}
	buroSubeEkleGuncelle(entity: BuroSubeInfo): Observable<any> {
		return this.http.post<BuroSubeInfo>(
			environment.API_BURO_SUBE_URL,
			entity
		);
	}
	getKullaniciSubeler(): Observable<BuroSubeInfo[]> {
		return this.http.get<BuroSubeInfo[]>(`${environment.API_BURO_SUBE_URL}kullanicisubeler`);
	}
	buroKullaniciEkleGuncelle(entity: KullaniciInfo): Observable<any> {
		return this.http.post<KullaniciInfo>(
			environment.API_BURO_KULLANICI_URL,
			entity
		);
	}
	getBuroSayaclari(id: number): Observable<FaturaNumaraSayacInfo[]> {
		return this.http.get<FaturaNumaraSayacInfo[]>(`${environment.API_BURO_KULLANICI_URL}getburosayaclari/${id}`);
	}

	syncBuroKullaniciSayac(buro_mu: boolean, buro_kullanici_id: number, sayacIdList: number[]): Observable<any> {
		return this.http.post<any>(
			`${environment.API_BURO_KULLANICI_URL}syncBuroKullaniciSayac?buro_mu=${buro_mu}&buro_kullanici_id=${buro_kullanici_id}`,
			sayacIdList
		);
	}

	getKullaniciSayaclari(buro_mu: boolean, buro_kullanici_id: number): Observable<FaturaNumaraSayacInfo[]> {
		return this.http.get<FaturaNumaraSayacInfo[]>(
			`${environment.API_BURO_KULLANICI_URL}getKullaniciSayaclari/${buro_kullanici_id}?buro_mu=${buro_mu}`
		);
	}

	kaydetBuroKullanici(info: KullaniciInfo): Observable<any> {
		return this.http.post<KullaniciInfo>(
			`${environment.API_BURO_KULLANICI_URL}kullanicikaydet`,
			info
		);
	}
	buroBankaSil(id: number): Observable<any> {
		return this.http.delete<any>(
			environment.API_BURO_BANKA_URL + id.toString()
		);
	}
	buroSubeSil(id: number): Observable<any> {
		return this.http.delete<any>(
			environment.API_BURO_SUBE_URL + id.toString()
		);
	}
	buroBankaDurumunuDegistir(id: number): Observable<any> {
		return this.http.get<any>(
			environment.API_BURO_BANKA_URL + "durumunudegistir/" + id.toString()
		);
	}
	buroSubeDurumunuDegistir(id: number): Observable<any> {
		return this.http.get<any>(
			environment.API_BURO_SUBE_URL + "durumunudegistir/" + id.toString()
		);
	}
	buroLogoImzaDurumuSorgula(): Observable<boolean> {
		return this.http.get<boolean>(
			environment.API_BUROLAR_URL + "burologoimzadurumusorgula"
		);
	}
	buroMeslekSorgula(): Observable<any> {
		return this.http.get<any>(
			environment.API_BUROLAR_URL + "buromesleksorgula"
		);
	}
	buroMuhasebeciMaliMusavirEkleGuncelle(
		entity: BuroMuhasebeciMaliMusaivirInfo
	): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(
			environment.API_BURO_MUHASEBECI_MALI_MUSAVIR_URL,
			entity
		);
	}
	buroMuhasebeciMaliMusavirSelect(): Observable<BuroMuhasebeciMaliMusaivirInfo> {
		return this.http.get<BuroMuhasebeciMaliMusaivirInfo>(
			environment.API_BURO_MUHASEBECI_MALI_MUSAVIR_URL
		);
	}
	buroMuhasebeciMaliMusavireGonder(entity: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(
			environment.API_BURO_MUHASEBECI_MALI_MUSAVIR_URL +
			"malimusaviregonder/",
			entity
		);
	}
	buroMuhasebeciMaliMusavirSil(): Observable<any> {
		return this.http.delete<any>(
			environment.API_BURO_MUHASEBECI_MALI_MUSAVIR_URL
		);
	}
	buroMuhasebeciMaliMusavireGonderExcel(entity: any): Observable<IslemSonuc> {
		return this.http.post<IslemSonuc>(
			environment.API_BURO_MUHASEBECI_MALI_MUSAVIR_URL +
			"malimusaviregonderexcel",
			entity
		);
	}

	GibEFaturaBasvuru(): Observable<boolean> {
		return this.http.get<boolean>(environment.API_BUROLAR_URL + 'gibefaturabasvuru')
	}

	OnMuhasebeEntegrasyonSorgula(encryptBuroId: string): Observable<boolean> {
		return this.http.get<boolean>(environment.API_BUROLAR_URL + 'onMuhasebeEntegrasyonSorgula' +
			'?encryptBrId=' + encryptBuroId
		)
	}

	getUniveraSozlesme(): Observable<Blob> {
		return this.http.get<Blob>(environment.API_BUROLAR_URL + 'sozlesme');
	}

	//degisecek kaldirilacak sozlesme icin
	getTestPdf(): Observable<Blob> {
		return this.http.get(environment.API_BUROLAR_URL + 'test-pdf', {
			responseType: 'blob'
		});
	}
}
